import base from './base_en.json';

const extra = {
  'footer_text': `For further enquiries,
  please visit 
  INTEGRATED SERVICES CENTRE OF IAM
  Address: Avenida da Praia Grande, n.º 762-804, 
  Edifício China Plaza , 2.º andar, Macau
  Macao Government Services Centre
  Address: Rua Nova da Areia Preta, n.º 52, Macau
  Macao Government Services Centre in Islands
  Address: Rua de Coimbra, no. 225, 3rd Floor, Taipa
  Hotline: (853) 2822 5000  Fax: (853) 2822 3000`,
}

const output = Object.assign({}, base, extra);
export default output;
